import slider from '../helpers/slider';
import reveal from '../helpers/reveal';
import { TinySliderSettings } from 'tiny-slider';

interface IPromoBarConfig {
  htmlElement: HTMLElement,
  selectors: IPromoBarSelectors,
  slider: IPromoBarSlider
}

interface IPromoBarSlider {
  htmlElement: HTMLElement,
  settings: TinySliderSettings
}

interface IPromoBarSelectors {
  main: string,
  slider: string
}

class PromoBar {
  
  private config: IPromoBarConfig;
  
  constructor() {
    this.config = {
      htmlElement: null,
      slider: {
        htmlElement: null,
        settings: {
          items: 1,
          autoplay: true,
          autoplayButton: false,
          autoplayButtonOutput: false,
          gutter: 0
        }
      },
      selectors: {
        main: '[data-promo-bar]', 
        slider: '[data-promo-bar-slider]'
      }
    }
  }
  
  public init() {
    document.querySelectorAll(this.config.selectors.main).forEach((htmlElement: HTMLElement) => {
      this.load(htmlElement);
    });
  }

  public load(htmlElement: HTMLElement) {
    this.config.htmlElement = htmlElement;
    this.config.slider.htmlElement = this.config.htmlElement.querySelector(this.config.selectors.slider);
    if (this.config.slider.htmlElement) this.slider();
    if (this.config.htmlElement) reveal.closestHideClassName(this.config.htmlElement);
  }

  private slider() {
    return slider.init(this.config.slider.htmlElement, this.config.slider.settings);
  }
}

export default new PromoBar();